import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Surveys } from 'src/Models/Surveys';

@Component({
  selector: 'thanks-message-video',
  templateUrl: './thanks-message-video.component.html',
  styleUrls: ['./thanks-message-video.component.sass']
})
export class ThanksMessageVideoComponent implements OnChanges {
  @Input() formRespose: FormGroup;
  @Input() survey: Surveys;
  @Input() objColor: any;
  @Input() jsonColor: any;
  constructor() { }

  ngOnChanges(): void {
  }

  tagsReplace(text) {
    text = text.replace(/{FirstName}/g, this.formRespose.get('name').value);
    text = text.replace(/{Contato.Nome}/g, this.formRespose.get('name').value);
    text = text.replace(/{Company.Name}/g, this.survey.companies.full_name);
    // text = this.propertiesReplace(text);
    return text;
  }

}
